import React, { FC } from 'react'
import { payPlanMobx } from '@mobxStore'
import WechatSimpleItem from './SimpleItem'
import { observer } from 'mobx-react'

interface IProps {
  selected?: boolean;
}

const WechatPayMethodItem: FC<IProps> = ({ selected }) => {
  const amount = payPlanMobx.externalMethod?.amount
  return (
    <WechatSimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('WechatPayWeb')} />
  )
}

export default observer(WechatPayMethodItem)
